// extracted by mini-css-extract-plugin
export var orderDetails = "_oe-2";
export var orderImage = "_oe-1";
export var orderMeta = "_oe-3";
export var orderSummary = "_oe-0";
export var rightArrow = "_oe-4";